import get from 'lodash/get'

export default function (binding, property) {
  let toggle = false
  if (binding._controlType === 'list-item') {
    toggle = get(binding, `parent._toggle._${binding._controlType}`)
  } else {
    toggle = binding._toggle
  }

  // ADV: no longer working, use "matchRegex" on property functionality instead
  // Change image2 -> image, etc...
  // const strippedProperty = property.replace(/[2-4]$/, '')

  // return true when there is no toggle or is set to tru
  return !toggle || toggle[property] !== false
}
